import React from 'react';
import { parseISO, format } from 'date-fns';

const Time = ({ date, format: dateFormat }) => {
  let time;
  if (typeof date === 'number') {
    time = new Date(date * 1000);
  } else {
    time = parseISO(date);
  }

  return <time dateTime={time.toISOString()}>{format(time, dateFormat)}</time>;
};

export default Time;
